export type ConsentSettings = Required<Pick<ConsentParams, 'ad_storage' | 'analytics_storage' | 'ad_user_data' | 'ad_personalization'>> & Pick<ConsentParams, 'functionality_storage' | 'personalization_storage' | 'security_storage'>;
/**
 * @description Send Google Consent v2 updates using gtag API
 * @param consent - Consent settings object
 */
export default function sendGoogleConsent(consent: ConsentSettings): void {
  if (typeof window === 'undefined') return;

  if (window.gtag) {
    window.gtag('consent', 'update', consent);
  } else if (window.dataLayer) {
    // Fallback if gtag isn’t available for some reason
    window.dataLayer.push(['consent', 'update', consent]);
  }

  // A consent update is not a GTM trigger. Announce it so consent-gated tags that were blocked
  // at page load (consent is re-applied after hydration) can fire once it is granted.
  window.dataLayer?.push({ event: 'consent_update' });
}
